/**
 * fca-ship-bar.js — Filaments.ca tiered shipping milestone bar
 * Loaded as a theme asset so it's always registered, even when sections
 * are re-rendered by Shopify's section rendering API.
 *
 * Tiers (in cents):
 *   < $60   → standard shipping
 *   $60+    → $15 flat rate
 *   $100+   → $10 flat rate
 *   $140+   → FREE shipping
 */

(function () {
  const TIER1 = 6000;
  const TIER2 = 10000;
  const TIER3 = 14000;

  function fmt(cents) {
    const val = cents / 100;
    return '$' + (Number.isInteger(val) ? val : val.toFixed(2));
  }

  function updateBar(el, totalCents) {
    const msg     = el.querySelector('.fca-ship-bar__msg');
    const markers = el.querySelectorAll('.fca-ship-bar__marker');
    if (!msg) return;
    msg.style.fontSize = '1.1rem';

    let pct, msgHTML;

    // Linear fill: progress across full $0–$140 range
    pct = Math.min(Math.round(totalCents / TIER3 * 100), 100);

    if (totalCents >= TIER3) {
      msgHTML = '🎉 <strong>You\'ve unlocked FREE shipping!</strong>';
    } else if (totalCents >= TIER2) {
      msgHTML = `Spend <strong>${fmt(TIER3 - totalCents)}</strong> more to unlock <strong>FREE</strong> shipping &nbsp;·&nbsp; <span class="fca-ship-bar__free-hint">FREE at $140</span>`;
    } else if (totalCents >= TIER1) {
      msgHTML = `Spend <strong>${fmt(TIER2 - totalCents)}</strong> more to unlock <strong>$10 flat rate</strong> shipping &nbsp;·&nbsp; <span class="fca-ship-bar__free-hint">FREE at $140</span>`;
    } else {
      msgHTML = `Spend <strong>${fmt(TIER1 - totalCents)}</strong> more to unlock <strong>$15 flat rate</strong> shipping &nbsp;·&nbsp; <span class="fca-ship-bar__free-hint">FREE at $140</span>`;
    }

    const w = Math.min(pct, 100);
    const fill = el.querySelector('.fca-ship-bar__fill');
    if (fill) {
      fill.style.cssText = `display:block; height:8px; width:${w}%; max-width:100%; background-color:#1a6e30; border-radius:4px; transition:width 0.4s ease;`;
    }
    msg.innerHTML = msgHTML;

    // Update marker colours inline
    const thresholds = [TIER1, TIER2, TIER3];
    const positions  = ['42.86%', '71.43%', '100%'];
    markers.forEach((m, i) => {
      if (!m) return;
      const reached = totalCents >= thresholds[i];
      m.style.backgroundColor = reached ? '#1a6e30' : '#ccc';
      m.style.boxShadow = `0 0 0 1px ${reached ? '#1a6e30' : '#ccc'}`;
      m.style.left = positions[i];
      const label = m.querySelector('span');
      if (label) {
        label.style.color = reached ? '#1a6e30' : '#555';
        label.style.fontSize = '0.85rem';
      }
    });
  }

  function initAllBars(totalCents) {
    document.querySelectorAll('.fca-ship-bar').forEach(el => {
      updateBar(el, totalCents);
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => initAllBars(cart.total_price))
      .catch(() => {});
  }

  // Init from server-rendered data-cart-total on page load
  function initFromDOM() {
    document.querySelectorAll('.fca-ship-bar').forEach(el => {
      const total = parseInt(el.dataset.cartTotal, 10);
      if (!isNaN(total)) updateBar(el, total);
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromDOM);
  } else {
    initFromDOM();
  }

  // Re-init when Shopify re-renders sections (cart drawer, etc.)
  document.addEventListener('shopify:section:load', initFromDOM);

  // Re-init after cart quantity changes — these are the events this theme fires
  document.addEventListener('afterCartChanged', fetchCartAndUpdate);
  document.addEventListener('afterUpdateQuantity', fetchCartAndUpdate);

  // Also watch for DOM mutations in case the section HTML is swapped
  // (cart drawer uses innerHTML replacement)
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.fca-ship-bar:not([data-initialized])').forEach(el => {
      el.setAttribute('data-initialized', '1');
      const total = parseInt(el.dataset.cartTotal, 10);
      if (!isNaN(total)) updateBar(el, total);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
